module.exports = __webpack_public_path__ + "img/CellCycle-BLCA_GSE171351.ff7c999b.png";